document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const storeCurrency = document.body.dataset.currency || 'EUR';
  const storeLocale = document.documentElement.lang || 'en';
  const moneyFormatter = new Intl.NumberFormat(storeLocale, { style: 'currency', currency: storeCurrency });
  document.querySelectorAll('[data-money-price]').forEach((price) => {
    const cents = Number(price.dataset.moneyPrice || 0);
    if (Number.isFinite(cents)) price.textContent = moneyFormatter.format(cents / 100);
  });
  const trackConversion = (event, details = {}) => {
    if (!Array.isArray(window.dataLayer)) window.dataLayer = [];
    window.dataLayer.push({ event, ...details });
    document.dispatchEvent(new CustomEvent('wote:conversion', { detail: { event, ...details } }));
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (!link) return;
    if (link.matches('.category-card')) trackConversion('category_selected', { category: link.querySelector('strong')?.textContent?.trim() || '', destination: link.pathname });
    if (link.href.includes('ig.me/m/whispersoftheeast')) trackConversion('instagram_contact_clicked', { location: link.closest('section,header,footer,aside')?.id || link.closest('section,header,footer,aside')?.className || 'site' });
    if (link.protocol === 'mailto:') trackConversion('email_contact_clicked', { location: link.closest('section,header,footer,aside')?.id || link.closest('section,header,footer,aside')?.className || 'site' });
  });

  document.querySelectorAll('[data-category-toggle]').forEach((button) => {
    const grid = button.closest('.page-width')?.querySelector('.category-grid:not(.category-grid--secondary)');
    if (!grid) return;
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      grid.classList.toggle('is-expanded', !expanded);
      button.querySelector('span').textContent = expanded ? 'View all 11 spell themes' : 'Show fewer spell themes';
      trackConversion(expanded ? 'spell_themes_collapsed' : 'spell_themes_expanded');
    });
  });

  document.querySelectorAll('[data-depth-choice]').forEach((link) => link.addEventListener('click', () => {
    window.sessionStorage.setItem('woteDepth', link.dataset.depthChoice);
    trackConversion('depth_guide_selected', { depth: link.dataset.depthChoice });
  }));
  document.querySelectorAll('.category-card[href*="/products/"]').forEach((link) => link.addEventListener('click', () => {
    const savedDepth = window.sessionStorage.getItem('woteDepth');
    if (!savedDepth) return;
    const destination = new URL(link.href, window.location.origin);
    destination.searchParams.set('depth', savedDepth);
    link.href = destination.toString();
  }));
  const revealElements = [...document.querySelectorAll('.category-card, .tier, .step, .client-feedback__layout > *, .product-layout > *, .included-grid > *, .cart-item, .confidence-strip article')];
  if (reduceMotion) {
    revealElements.forEach((element) => element.classList.add('is-visible'));
  } else if ('IntersectionObserver' in window) {
    revealElements.forEach((element, index) => {
      element.classList.add('motion-reveal');
      element.style.setProperty('--reveal-delay', `${Math.min(index % 4, 3) * 55}ms`);
    });
    document.documentElement.classList.add('motion-ready');
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });
    revealElements.forEach((element) => revealObserver.observe(element));
  }

  const ticker = document.querySelector('[data-trust-ticker]');
  if (ticker) {
    const messages = [...ticker.querySelectorAll('[data-trust-message]')];
    const previous = ticker.querySelector('[data-trust-prev]');
    const next = ticker.querySelector('[data-trust-next]');
    let active = 0;
    let timer;

    const showMessage = (index) => {
      active = (index + messages.length) % messages.length;
      messages.forEach((message, messageIndex) => {
        message.hidden = messageIndex !== active;
        message.classList.toggle('is-active', messageIndex === active);
      });
    };
    const stopRotation = () => window.clearInterval(timer);
    const startRotation = () => {
      stopRotation();
      if (ticker.hasAttribute('data-ticker-autoplay') && !reduceMotion && messages.length > 1) timer = window.setInterval(() => showMessage(active + 1), 5200);
    };

    previous?.addEventListener('click', () => { showMessage(active - 1); startRotation(); });
    next?.addEventListener('click', () => { showMessage(active + 1); startRotation(); });
    ticker.addEventListener('pointerenter', stopRotation);
    ticker.addEventListener('pointerleave', startRotation);
    ticker.addEventListener('focusin', stopRotation);
    ticker.addEventListener('focusout', startRotation);
    showMessage(0);
    startRotation();
  }

  document.querySelectorAll('[data-feedback-track]').forEach((track) => {
    const section = track.closest('.client-feedback__highlights');
    const previous = section?.querySelector('[data-feedback-prev]');
    const next = section?.querySelector('[data-feedback-next]');
    const status = section?.querySelector('[data-feedback-status]');
    const cards = [...track.querySelectorAll('[data-feedback-card]')];
    if (!cards.length) return;
    let active = 0;
    let timer;
    let scrollFrame;
    const updateStatus = () => {
      if (status) status.textContent = `${active + 1} / ${cards.length}`;
      cards.forEach((card, index) => card.toggleAttribute('data-current', index === active));
    };
    const goTo = (index) => {
      active = (index + cards.length) % cards.length;
      const left = cards[active].offsetLeft - cards[0].offsetLeft;
      track.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
      updateStatus();
    };
    const syncFromScroll = () => {
      const nearest = cards.reduce((best, card, index) => {
        const distance = Math.abs(track.scrollLeft - (card.offsetLeft - cards[0].offsetLeft));
        return distance < best.distance ? { index, distance } : best;
      }, { index: active, distance: Infinity });
      active = nearest.index;
      updateStatus();
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (track.hasAttribute('data-feedback-autoplay') && !reduceMotion && document.visibilityState === 'visible') timer = window.setInterval(() => goTo(active + 1), 7000);
    };
    previous?.addEventListener('click', () => { goTo(active - 1); start(); });
    next?.addEventListener('click', () => { goTo(active + 1); start(); });
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(syncFromScroll);
    }, { passive: true });
    track.addEventListener('pointerenter', stop);
    track.addEventListener('pointerleave', start);
    track.addEventListener('focusin', stop);
    track.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    updateStatus();
    start();
  });
  document.querySelectorAll('.review-library').forEach((library) => library.addEventListener('toggle', () => {
    if (library.open) trackConversion('additional_reviews_opened');
  }));

  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    const menuShell = document.querySelector('.site-header-shell');
    const positionMenu = () => { if(menuShell) menu.style.top = `${Math.max(0, menuShell.getBoundingClientRect().bottom)}px`; };
    const setMenuOpen = (open, restoreFocus = false) => {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      toggle.textContent = open ? '×' : '☰';
      menu.hidden = !open;
      document.body.classList.toggle('menu-open', open);
      ['#MainContent','.site-footer','.quiet-contact'].forEach(selector => {
        const region = document.querySelector(selector);
        if(region) region.inert = open;
      });
      if(open) { positionMenu(); menu.querySelector('a')?.focus(); }
      else if(restoreFocus) toggle.focus();
    };
    toggle.addEventListener('click', () => setMenuOpen(toggle.getAttribute('aria-expanded') !== 'true', true));
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      // The Shop link manages its own first-click expansion and second-click
      // navigation; never collapse the mobile drawer on that trigger.
      if (link.matches('[data-shop-trigger]')) return;
      setMenuOpen(false);
    }));
    document.addEventListener('keydown', event => {
      if (menu.hidden) return;
      if(event.key === 'Escape'){event.preventDefault();setMenuOpen(false,true);return;}
      if(event.key !== 'Tab') return;
      const items = [toggle,...menu.querySelectorAll('a,summary,button')].filter(el=>el.getClientRects().length);
      const first=items[0], last=items[items.length-1];
      if(event.shiftKey && document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first.focus();}
    });
    matchMedia('(min-width: 1251px)').addEventListener('change', event=>{if(event.matches) setMenuOpen(false);});
    if(menuShell && typeof ResizeObserver === 'function') new ResizeObserver(()=>{if(!menu.hidden) positionMenu();}).observe(menuShell);
  }

  document.querySelectorAll('.product-gallery').forEach((gallery) => {
    const mainImage = gallery.querySelector('.product-gallery__main img');
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-src]')];
    if (!mainImage || !thumbnails.length) return;
    thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => {
      mainImage.src = thumbnail.dataset.gallerySrc;
      mainImage.removeAttribute('srcset');
      mainImage.alt = thumbnail.dataset.galleryAlt || mainImage.alt;
      thumbnails.forEach((item) => item.classList.toggle('is-active', item === thumbnail));
    }));
  });

  document.querySelectorAll('[data-personalized-form]').forEach((wrapper) => {
    const form = wrapper.querySelector('form');
    const booster = wrapper.querySelector('[data-booster]');
    const total = wrapper.querySelector('[data-order-total]');
    const button = wrapper.querySelector('[data-order-button]');
    const error = wrapper.querySelector('[data-order-error]');
    const recovery = wrapper.querySelector('[data-order-recovery]');
    const startNew = wrapper.querySelector('[data-order-new]');
    const currency = wrapper.dataset.currency || 'EUR';
    const boosterPrice = Number(wrapper.dataset.boosterPrice || 0);
    const flowSteps = [...wrapper.querySelectorAll('[data-flow-step]')];
    const flowNavigation = [...wrapper.querySelectorAll('[data-flow-nav]')];
    const finalFlow = Math.max(...flowSteps.map((step) => Number(step.dataset.flowStep)), 1);
    let currentFlow = Number(flowSteps.find((step) => step.classList.contains('is-active'))?.dataset.flowStep || flowSteps[0]?.dataset.flowStep || 1);
    let highestFlow = currentFlow;
    let submitting = false;
    let requestStorage;
    try { requestStorage = window.sessionStorage; } catch (_) {}
    const editableFields = [...(form?.querySelectorAll('[name="id"], textarea, input[type="text"], input[type="file"]') || [])];
    const disabledOriginally = new Set(editableFields.filter((field) => field.disabled));
    const cartRequest = window.WoteCart?.createCartRequest({
      fetch: window.fetch.bind(window), root: window.Shopify?.routes?.root || '/', storage: requestStorage,
      key: `woteCartRequest:${wrapper.dataset.productHandle}`,
      onState: (state) => {
        wrapper.classList.toggle('is-order-added', Boolean(state.main));
        editableFields.forEach((field) => { field.disabled = Boolean(state.main) || disabledOriginally.has(field); });
      }
    });
    // Validate the visible step ourselves before moving focus to an invalid
    // field; the browser cannot focus required fields in a hidden flow panel.
    if (form) form.noValidate = true;

    const showFlowStep = (stepNumber, shouldScroll = true) => {
      if (!flowSteps.some((step) => Number(step.dataset.flowStep) === stepNumber)) return;
      currentFlow = stepNumber;
      flowSteps.forEach((step) => step.classList.toggle('is-active', Number(step.dataset.flowStep) === stepNumber));
      flowNavigation.forEach((item) => {
        const itemStep = Number(item.dataset.flowNav);
        item.classList.toggle('is-active', itemStep === stepNumber);
        item.classList.toggle('is-complete', itemStep < stepNumber);
        item.disabled = itemStep > highestFlow;
        if (itemStep === stepNumber) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      wrapper.classList.toggle('flow-at-final', stepNumber === finalFlow);
      if (stepNumber === finalFlow) updateReview();
      if (shouldScroll) {
        wrapper.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        const heading = wrapper.querySelector(`[data-flow-step="${stepNumber}"] .personalization__label`);
        heading?.setAttribute('tabindex', '-1');
        heading?.focus({ preventScroll: true });
      }
      trackConversion('personalization_step_viewed', { product: wrapper.dataset.productHandle || '', step: stepNumber });
    };
    wrapper.querySelectorAll('[data-personalization-next]').forEach((button) => button.addEventListener('click', () => {
      const currentStep = wrapper.querySelector(`[data-flow-step="${currentFlow}"]`);
      const invalid = [...(currentStep?.querySelectorAll('input, textarea, select') || [])].find((field) => !field.checkValidity());
      if (invalid) {
        invalid.reportValidity();
        return;
      }
      const nextStep = Number(button.dataset.personalizationNext);
      highestFlow = Math.max(highestFlow, nextStep);
      showFlowStep(nextStep);
    }));
    flowNavigation.forEach((button) => button.addEventListener('click', () => {
      const destination = Number(button.dataset.flowNav);
      if (destination <= highestFlow) showFlowStep(destination);
    }));

    const selectedPrice = () => {
      const chosen = form?.querySelector('[name="id"]:checked') || form?.querySelector('[name="id"]');
      return Number(chosen?.dataset.variantPrice || 0);
    };
    const updateReview = () => {
      const chosen = form?.querySelector('[name="id"]:checked') || form?.querySelector('[name="id"]');
      const depth = wrapper.querySelector('[data-review-depth]');
      const price = wrapper.querySelector('[data-review-price]');
      if (depth) depth.textContent = chosen?.dataset.variantTitle || 'Personal preparation';
      if (price) price.textContent = new Intl.NumberFormat('en', { style: 'currency', currency }).format(selectedPrice() / 100);
    };
    const updateTotal = () => {
      if (!total) return;
      const cents = selectedPrice() + (booster?.checked ? boosterPrice : 0);
      total.textContent = new Intl.NumberFormat('en', { style: 'currency', currency }).format(cents / 100);
      updateReview();
    };
    wrapper.querySelectorAll('[name="id"], [data-booster]').forEach((input) => input.addEventListener('change', () => {
      updateTotal();
      if (button && !submitting && cartRequest?.getState()?.main) button.textContent = booster?.checked ? 'Retry optional booster' : 'Continue to my bag';
      if (input.matches('input[type="radio"][name="id"]') && input.checked) trackConversion('product_depth_selected', { product: wrapper.dataset.productHandle || '', variant: input.dataset.variantTitle || '', price: Number(input.dataset.variantPrice || 0) / 100 });
      if (input.matches('[data-booster]')) trackConversion('booster_toggled', { product: wrapper.dataset.productHandle || '', selected: input.checked });
      if (!input.matches('input[type="radio"][name="id"]') || !input.checked) return;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url);

      if (!input.dataset.variantImage) return;
      const gallery = wrapper.closest('.product-layout')?.querySelector('.product-gallery');
      const mainImage = gallery?.querySelector('.product-gallery__main img');
      if (!mainImage) return;
      mainImage.src = input.dataset.variantImage;
      mainImage.removeAttribute('srcset');
      mainImage.alt = input.dataset.variantTitle || mainImage.alt;
      gallery.querySelectorAll('.product-gallery__thumb').forEach((thumbnail) => {
        thumbnail.classList.toggle('is-active', thumbnail.dataset.gallerySrc === input.dataset.variantImage);
      });
    }));
    wrapper.querySelectorAll('[data-file-input]').forEach((input) => {
      const name = input.closest('.file-field')?.querySelector('[data-file-name]');
      input.addEventListener('change', () => {
        if (name) name.textContent = input.files?.[0]?.name || 'No file selected';
      });
    });
    let savedDepth = '';
    try { savedDepth = requestStorage?.getItem('woteDepth') || ''; } catch (_) {}
    const requestedDepth = Number(new URL(window.location.href).searchParams.get('depth') || savedDepth || 0);
    if (!new URL(window.location.href).searchParams.has('variant') && requestedDepth > 0) {
      const depthInput = wrapper.querySelectorAll('input[type="radio"][name="id"]')[requestedDepth - 1];
      if (depthInput && !depthInput.disabled) {
        depthInput.checked = true;
        depthInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      try { requestStorage?.removeItem('woteDepth'); } catch (_) {}
    }
    updateTotal();
    if (flowSteps.length) showFlowStep(currentFlow, false);
    if (cartRequest?.getState()?.attempted) {
      const previousMainAdded = cartRequest.getState().main;
      if (previousMainAdded) editableFields.forEach((field) => { field.disabled = true; });
      if (error) { error.textContent = previousMainAdded ? 'Your earlier order was added. Its original details are in your bag; the fields on this page will not replace them. Continue to your bag, or explicitly start a separate new order below.' : 'An earlier order attempt is saved in this tab. Your bag will be checked before anything is added again. Open your bag below to review it.'; error.classList.add('is-visible'); }
      if (recovery) recovery.hidden = false;
      if (startNew) startNew.hidden = false;
    }
    startNew?.addEventListener('click', () => {
      if (!cartRequest?.startNew()) return;
      submitting = false;
      error?.classList.remove('is-visible');
      if (recovery) recovery.hidden = true;
      startNew.hidden = true;
      if (button) { button.disabled = false; button.textContent = 'Add to bag →'; }
      if (flowSteps.length) showFlowStep(Number(flowSteps[0].dataset.flowStep));
    });
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted || !cartRequest?.getState()?.attempted) return;
      submitting = false;
      if (button) { button.disabled = false; button.textContent = 'Check my bag & continue'; }
      if (recovery) recovery.hidden = false;
      if (startNew) startNew.hidden = false;
    });

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting) return;
      const invalid = [...form.querySelectorAll('input, textarea, select')].find((field) => !field.checkValidity());
      if (invalid) {
        const invalidStep = Number(invalid.closest('[data-flow-step]')?.dataset.flowStep || 0);
        if (invalidStep) { highestFlow = Math.max(highestFlow, invalidStep); showFlowStep(invalidStep); }
        invalid.reportValidity();
        return;
      }
      if (flowSteps.length && currentFlow !== finalFlow) { highestFlow = finalFlow; showFlowStep(finalFlow); return; }
      if (!cartRequest) {
        if (error) { error.textContent = 'The order form is still loading. Please refresh this page before adding your order.'; error.classList.add('is-visible'); }
        return;
      }
      submitting = true;
      trackConversion('personalized_order_submitted', { product: wrapper.dataset.productHandle || '', variant: form.querySelector('[name="id"]:checked')?.dataset.variantTitle || '', booster: Boolean(booster?.checked) });
      const originalText = button?.textContent || '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding your order...';
      }
      error?.classList.remove('is-visible');
      try {
        const result = await cartRequest.run({ getFormData: () => {
          const missing = [...form.querySelectorAll('input, textarea, select')].find((field) => !field.checkValidity());
          if (missing) {
            const missingStep = Number(missing.closest('[data-flow-step]')?.dataset.flowStep || 0);
            if (missingStep) { highestFlow = Math.max(highestFlow, missingStep); showFlowStep(missingStep); }
            missing.reportValidity();
            throw new Error('Your earlier item is no longer in the bag. Please complete your details before adding a new order.');
          }
          return new FormData(form);
        }, boosterId: booster?.checked ? booster.value : null });
        if (result.busy) return;
        const route = window.Shopify?.routes?.root || '/';
        const discount = wrapper.dataset.boosterCode;
        cartRequest.complete();
        window.location.href = result.booster && discount ? `${route}discount/${encodeURIComponent(discount)}?redirect=${encodeURIComponent(`${route}cart`)}` : `${route}cart`;
      } catch (problem) {
        if (error) {
          error.textContent = problem.message || 'Please try again or message me on Instagram.';
          error.classList.add('is-visible');
        }
        if (button) {
          button.disabled = false;
          button.textContent = cartRequest.getState()?.main ? 'Retry optional booster' : originalText;
        }
        if (recovery) recovery.hidden = false;
        if (startNew) startNew.hidden = false;
        submitting = false;
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const moonPortal = document.querySelector('[data-moon-portal]');
  if (moonPortal) {
    const DAY = 86400000;
    const LUNATION = 29.530588853;
    const NEW_MOON_EPOCH = Date.UTC(2000, 0, 6, 18, 14);
    const phaseMilestones = [
      { fraction: 0, name: 'New Moon', symbol: '●', invitation: 'Begin quietly', guidance: 'Name one intention and one practical action small enough to begin now.' },
      { fraction: .25, name: 'First Quarter', symbol: '◐', invitation: 'Choose movement', guidance: 'Notice the first resistance. Support your intention with one clear decision.' },
      { fraction: .5, name: 'Full Moon', symbol: '○', invitation: 'See what is visible', guidance: 'Take an honest inventory of what has grown, what needs care and what is complete.' },
      { fraction: .75, name: 'Last Quarter', symbol: '◑', invitation: 'Release and integrate', guidance: 'Clear one burden, complete one loose end and protect space for what comes next.' }
    ];
    const phaseDetails = [
      { max: .0625, name: 'New Moon', symbol: '●', guidance: 'A quiet threshold for intention, rest and the first small beginning.', practice: 'Write one sentence beginning with “I am making room for…”. Choose one action for tomorrow.' },
      { max: .1875, name: 'Waxing Crescent', symbol: '☽', guidance: 'A growing phase for curiosity, preparation and gentle forward movement.', practice: 'Gather what supports your intention. Remove one avoidable obstacle from the path.' },
      { max: .3125, name: 'First Quarter', symbol: '◐', guidance: 'A decisive phase for action, adjustment and meeting resistance clearly.', practice: 'Name the decision you have delayed. Take the smallest meaningful step before the day ends.' },
      { max: .4375, name: 'Waxing Gibbous', symbol: '◕', guidance: 'A refining phase for patience, correction and strengthening what is already growing.', practice: 'Review what you began. Keep what is working and change one detail that is not.' },
      { max: .5625, name: 'Full Moon', symbol: '○', guidance: 'An illuminating phase for recognition, gratitude and honest inventory.', practice: 'Write three lines: what grew, what became visible, and what now asks for care.' },
      { max: .6875, name: 'Waning Gibbous', symbol: '◔', guidance: 'A sharing phase for integration, understanding and passing wisdom forward.', practice: 'Name one lesson you can keep and one kindness or insight you can share.' },
      { max: .8125, name: 'Last Quarter', symbol: '◑', guidance: 'A clearing phase for boundaries, completion and deliberate release.', practice: 'Complete one loose end, clear one small space, and say no to one unnecessary demand.' },
      { max: .9375, name: 'Waning Crescent', symbol: '☾', guidance: 'A resting phase for listening, recovery and making room for the next cycle.', practice: 'Lower the noise for five minutes. Record what you no longer need to carry forward.' },
      { max: 1, name: 'New Moon approaching', symbol: '●', guidance: 'The cycle is closing. Rest, simplify and prepare a clean beginning.', practice: 'Choose what will remain behind when the next cycle begins.' }
    ];
    const fractionAt = (date) => {
      const cycles = (date.getTime() - NEW_MOON_EPOCH) / DAY / LUNATION;
      return ((cycles % 1) + 1) % 1;
    };
    const occurrenceAfter = (from, milestone) => {
      const cycles = (from.getTime() - NEW_MOON_EPOCH) / DAY / LUNATION;
      let cycleIndex = Math.floor(cycles - milestone.fraction) + 1;
      let timestamp = NEW_MOON_EPOCH + (cycleIndex + milestone.fraction) * LUNATION * DAY;
      if (timestamp <= from.getTime() + 60000) {
        cycleIndex += 1;
        timestamp = NEW_MOON_EPOCH + (cycleIndex + milestone.fraction) * LUNATION * DAY;
      }
      return { ...milestone, date: new Date(timestamp) };
    };
    const dateFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' });
    const shortDate = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
    const now = new Date();
    const fraction = fractionAt(now);
    const detail = phaseDetails.find((item) => fraction < item.max) || phaseDetails[0];
    const illumination = Math.round(((1 - Math.cos(2 * Math.PI * fraction)) / 2) * 100);
    const age = fraction * LUNATION;
    moonPortal.querySelector('[data-moon-name]').textContent = detail.name;
    moonPortal.querySelector('[data-moon-symbol]').textContent = detail.symbol;
    moonPortal.querySelector('[data-moon-illumination]').textContent = `${illumination}%`;
    moonPortal.querySelector('[data-moon-age]').textContent = age.toFixed(1);
    moonPortal.querySelector('[data-moon-guidance]').textContent = detail.guidance;
    moonPortal.querySelector('[data-moon-practice]').innerHTML = `<strong>A quiet practice for this phase</strong><p>${detail.practice}</p>`;
    const disc = moonPortal.querySelector('[data-moon-disc]');
    if (disc) {
      const darkness = Math.abs(.5 - fraction) * 2;
      const side = fraction < .5 ? 'left' : 'right';
      disc.style.setProperty('--moon-mask', `linear-gradient(to ${side}, rgba(35,31,28,${Math.max(.08, darkness).toFixed(2)}), rgba(35,31,28,.02))`);
    }

    const upcoming = phaseMilestones.map((milestone) => occurrenceAfter(now, milestone)).sort((a, b) => a.date - b.date)[0];
    moonPortal.querySelector('[data-next-event]').textContent = upcoming.name;
    moonPortal.querySelector('[data-next-date]').textContent = dateFormat.format(upcoming.date);
    const updateCountdown = () => {
      const distance = Math.max(0, upcoming.date.getTime() - Date.now());
      const days = Math.floor(distance / DAY);
      const hours = Math.floor((distance % DAY) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      moonPortal.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
      moonPortal.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      moonPortal.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
    };
    updateCountdown();
    window.setInterval(updateCountdown, 60000);

    const allEvents = [];
    let cursor = new Date(now);
    for (let index = 0; index < 8; index += 1) {
      const event = phaseMilestones.map((milestone) => occurrenceAfter(cursor, milestone)).sort((a, b) => a.date - b.date)[0];
      allEvents.push(event);
      cursor = new Date(event.date.getTime() + 120000);
    }
    moonPortal.querySelector('[data-moon-events]').innerHTML = allEvents.slice(0, 4).map((event) => `<article class="moon-event moon-event--${event.name.toLowerCase().replace(/\s+/g, '-')}"><span class="moon-event__symbol" aria-hidden="true">${event.symbol}</span><div><h3>${event.name}</h3><time datetime="${event.date.toISOString()}">${shortDate.format(event.date)}</time><p>${event.invitation}. ${event.guidance}</p></div></article>`).join('');

    const nextSeasonalEvents = [];
    const seasonTemplates = [
      { month: 2, day: 20, name: 'March Equinox', note: 'Balance, emergence and a change of season.' },
      { month: 5, day: 21, name: 'June Solstice', note: 'A threshold of light, vitality and perspective.' },
      { month: 8, day: 22, name: 'September Equinox', note: 'Balance, harvest and honest assessment.' },
      { month: 11, day: 21, name: 'December Solstice', note: 'Stillness, renewal and the return of light.' }
    ];
    [now.getFullYear(), now.getFullYear() + 1].forEach((year) => seasonTemplates.forEach((event) => {
      const date = new Date(year, event.month, event.day, 12, 0, 0);
      if (date > now) nextSeasonalEvents.push({ ...event, date });
    }));
    nextSeasonalEvents.sort((a, b) => a.date - b.date);
    moonPortal.querySelector('[data-seasonal-events]').innerHTML = nextSeasonalEvents.slice(0, 4).map((event) => `<article class="seasonal-event"><time datetime="${event.date.toISOString()}">${new Intl.DateTimeFormat('en', { day: 'numeric', month: 'short' }).format(event.date)}</time><strong>${event.name}</strong><small>${event.note}</small></article>`).join('');

    moonPortal.querySelector('[data-calendar-download]')?.addEventListener('click', () => {
      const formatICS = (date) => date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
      const end = new Date(upcoming.date.getTime() + 30 * 60000);
      const ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Whispers of the East//Living Moon Portal//EN', 'BEGIN:VEVENT', `UID:${upcoming.date.getTime()}@whispersoftheeast.com`, `DTSTAMP:${formatICS(new Date())}`, `DTSTART:${formatICS(upcoming.date)}`, `DTEND:${formatICS(end)}`, `SUMMARY:${upcoming.name} · Whispers of the East`, `DESCRIPTION:${upcoming.guidance}`, 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
      const link = document.createElement('a');
      link.href = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
      link.download = `whispers-${upcoming.name.toLowerCase().replace(/\s+/g, '-')}.ics`;
      link.click();
      window.setTimeout(() => URL.revokeObjectURL(link.href), 1000);
    });
  }

  // The adaptive page owns its controller; this preserves only legacy sections.
  const finder = document.querySelector('[data-ritual-finder]:not([data-adaptive-finder])');
  if (finder) {
    const form = finder.querySelector('[data-finder-form]');
    const steps = [...finder.querySelectorAll('[data-finder-step]')];
    const next = finder.querySelector('[data-finder-next]');
    const back = finder.querySelector('[data-finder-back]');
    const progress = finder.querySelector('[data-finder-progress]');
    const result = finder.querySelector('[data-finder-result]');
    let current = 0;
    const show = (index) => {
      current = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === current));
      back.hidden = current === 0;
      next.textContent = current === steps.length - 1 ? 'Reveal my guidance' : 'Continue';
      progress.style.width = `${((current + 1) / steps.length) * 100}%`;
      steps[current].querySelector('legend')?.focus?.();
    };
    const answers = () => Object.fromEntries(new FormData(form).entries());
    const productNames = {
      'love-relationship-personalized-slavic-ritual': 'Love & Relationship',
      'prosperity-finances-personalized-slavic-ritual': 'Prosperity & Finances',
      'protection-energy-ritual': 'Protection & Energy',
      'release-and-transformation-ritual': 'Release & Transformation',
      'spiritual-awakening-ritual': 'Spiritual Awakening',
      'customizable-protection-spell': 'Custom Spell'
    };
    const reveal = () => {
      const data = answers();
      const experienceDepth = { focused: 1, layered: 2, complete: 3 }[data.experience] || 1;
      const depth = Math.max(Number(data.layers || 1), experienceDepth);
      const depthNames = { 1: 'Little Charm', 2: 'Witch’s Brew', 3: 'Full Coven Ritual' };
      let title = `${productNames[data.theme] || 'Custom Spell'} · <em>${depthNames[depth]}</em>`;
      let copy = 'This pairing keeps the intention clear while matching the amount of depth you described. You can still change the depth on the product page.';
      let actions = `<a class="button button--light" href="/products/${data.theme}?depth=${depth}">Personalize this ritual →</a><a class="button button--outline" href="mailto:whispoftheeast@gmail.com?subject=Help%20choosing%20my%20ritual">Contact me by email</a>`;
      if (data.begin === 'reading' || data.direction === 'clarity' && data.begin !== 'ritual') {
        title = 'Slavic Folklore Tarot · <em>Reading</em>';
        copy = 'Because clarity comes first for you, a reading offers perspective before you decide whether a ritual is the right next step.';
        actions = `<a class="button button--light" href="/products/personalized-slavic-tarot-reading">Personalize this reading →</a><a class="button button--outline" href="mailto:whispoftheeast@gmail.com?subject=Question%20about%20a%20reading">Contact me by email</a>`;
      }
      if (data.begin === 'conversation') {
        title = 'Begin with a <em>private conversation.</em>';
        copy = 'Your situation deserves a little more context before you choose. The consultation is free and there is no obligation to order.';
        actions = `<a class="button button--light" href="https://ig.me/m/whispersoftheeast" target="_blank" rel="noopener">Message me on Instagram</a><a class="button button--outline" href="mailto:whispoftheeast@gmail.com?subject=Free%20ritual%20consultation">Contact me by email</a>`;
      }
      const visualClass = data.begin === 'reading' ? 'tarot' : data.begin === 'conversation' ? 'conversation' : `depth-${depth}`;
      result.innerHTML = `<div class="finder-result__visual finder-result__visual--${visualClass}" aria-hidden="true"></div><div class="finder-result__body"><span class="finder-result__eyebrow">Your personal starting point</span><h2>${title}</h2><p>${copy}</p><div class="finder-result__reason"><div><small>Your direction</small><strong>${data.direction === 'release' ? 'Release and clear' : data.direction === 'strengthen' ? 'Strengthen and protect' : data.direction === 'clarity' ? 'Understand before acting' : 'Open a path'}</strong></div><div><small>Your suggested depth</small><strong>${data.begin === 'reading' || data.begin === 'conversation' ? 'Begin with guidance' : depthNames[depth]}</strong></div></div><div class="finder-result__actions">${actions}</div><button class="finder-result__restart" type="button" data-finder-restart>Start again</button></div>`;
      form.hidden = true;
      result.hidden = false;
      progress.style.width = '100%';
      result.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      result.querySelector('[data-finder-restart]').addEventListener('click', () => {
        form.reset();
        result.hidden = true;
        form.hidden = false;
        show(0);
        finder.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    };
    next?.addEventListener('click', () => {
      const selected = steps[current].querySelector('input:checked');
      if (!selected) {
        steps[current].querySelector('input')?.reportValidity();
        return;
      }
      if (current < steps.length - 1) show(current + 1); else reveal();
    });
    back?.addEventListener('click', () => show(current - 1));
    show(0);
  }

  const grimoire = document.querySelector('[data-grimoire]');
  if (grimoire) {
    const search = grimoire.querySelector('[data-grimoire-search]');
    const filters = [...grimoire.querySelectorAll('[data-filter]')];
    const notes = [...grimoire.querySelectorAll('.grimoire-note')];
    const chapters = [...grimoire.querySelectorAll('[data-grimoire-chapter]')];
    const empty = grimoire.querySelector('[data-grimoire-empty]');
    let activeFilter = 'all';
    const apply = () => {
      const query = (search.value || '').trim().toLowerCase();
      let visible = 0;
      notes.forEach((note) => {
        const haystack = `${note.dataset.tags || ''} ${note.textContent}`.toLowerCase();
        const match = (activeFilter === 'all' || haystack.includes(activeFilter)) && (!query || haystack.includes(query));
        note.hidden = !match;
        if (match) visible += 1;
      });
      chapters.forEach((chapter) => {
        chapter.hidden = !chapter.querySelector('.grimoire-note:not([hidden])');
      });
      empty.hidden = visible !== 0;
    };
    search?.addEventListener('input', apply);
    filters.forEach((button) => button.addEventListener('click', () => {
      activeFilter = button.dataset.filter;
      filters.forEach((item) => item.classList.toggle('is-active', item === button));
      apply();
    }));
    grimoire.querySelectorAll('[data-grimoire-category]').forEach((card) => card.addEventListener('click', () => {
      activeFilter = card.dataset.grimoireCategory;
      filters.forEach((item) => item.classList.toggle('is-active', item.dataset.filter === activeFilter));
      apply();
      grimoire.querySelector('.grimoire-toolbar')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }));
  }
});
